// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__I3OSV","header":"Dashboard_header__K80kg"};